'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _carousel = require('./lib/carousel.js');

var _carousel2 = _interopRequireDefault(_carousel);

var _carouselCard = require('../carouselCard');

var _carouselCard2 = _interopRequireDefault(_carouselCard);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function SimpleCarousel(_ref) {
  var contents = _ref.contents,
      slideWidth = _ref.slideWidth,
      cellAlign = _ref.cellAlign,
      carouselCardHeight = _ref.carouselCardHeight,
      carouselCardAlignItems = _ref.carouselCardAlignItems,
      carouselCardBorder = _ref.carouselCardBorder,
      autoplay = _ref.autoplay,
      autoplayInterval = _ref.autoplayInterval,
      decorators = _ref.decorators,
      slidesToScroll = _ref.slidesToScroll,
      slidesToShow = _ref.slidesToShow;
  return _react2["default"].createElement(_carousel2["default"], {
    slidesToScroll: slidesToScroll,
    slidesToShow: slidesToShow,
    autoplay: autoplay || false,
    autoplayInterval: autoplayInterval || 3000,
    slideWidth: slideWidth || "175px",
    width: '100%',
    cellSpacing: 25,
    cellAlign: cellAlign || "center",
    swiping: true,
    wrapAround: true,
    decorators: decorators
  }, contents.map(function (content, i) {
    return _react2["default"].createElement(_carouselCard2["default"].component, {
      border: carouselCardBorder,
      alignItems: carouselCardAlignItems,
      height: carouselCardHeight,
      key: i,
      cardContent: content.cardContent,
      additionalText: content.additionalText
    });
  }));
}

var component = (0, _radium2["default"])(SimpleCarousel);
exports["default"] = {
  component: component
};